module.exports = {
  notifications: {
    AppointmentReminder: 'Appointments: Appointment reminder',
    AppointmentParticipationConfirmation: 'Appointments: Registration confirmation',
    AppointmentStartDateWasUpdated: 'Appointments: Appointment changed',
    AppReminder: 'User: We miss you',
    CommentDeletedForAuthor: 'Comments: Your comment was removed',
    CommentDeletedForReporter: 'Comments: Reported comment was removed',
    CommentNotDeleted: 'Comments: Reported comment was not removed',
    CompetitionInvitation: 'Competition: New competition',
    CompetitionReminder: 'Competition: Reminder',
    CompetitionResult: 'Competition: Results',
    CourseReminder: 'Courses: Course reminder',
    CoursesWeeklyReminder: 'Courses: Weekly course summary',
    ExpirationReminder: 'User: Your account will soon be deleted',
    GameAbort: 'Quiz-Challenge: Game aborted',
    GameDrawInfo: 'Quiz-Challenge: Game was a draw',
    GameInvitation: 'Quiz-Challenge: You got challenged by another player',
    GameLostInfo: 'Quiz-Challenge: Game lost',
    GameReminder: 'Quiz-Challenge: Your turn',
    GameWonInfo: 'Quiz-Challenge: Game won',
    LearningMaterialsPublished: 'Media library: New content',
    NewAppointment: 'Appointments: New appointment',
    NewCourseNotification: 'Courses: New course available',
    NewsPublishedInfo: 'News: New news entry',
    PassedCourse: 'Courses: Course finished successfully',
    QuizTeamAdd: 'Quiz-Challenge: You have been added to a quiz team',
    SubscriptionComment: 'Comments: New response',
    TestPassed: 'Test: Test passed',
    TestReminder: 'Test: Test participation reminder',
    WebinarReminder: 'Webinar: Meeting begins shortly',
    NewChatMessages: 'Chat: New message received',
    CommentReply: 'Comments: New response',
    NewCommunityPost: 'Community: New post',
    CommunityPostKnowledgeableUserRequested: 'Community post: Requests for your expertise',
    CommunityPostRandomUserRequested: 'Community post: Requests for your opinion',
  },
  description: 'Set the activities for which you want to receive e-mail notifications.',
  cant_deactivate: '<span>This e-mail can not be disabled. If you have any questions, please contact your <span class="underline">administrator</span>.</span>',
  save: 'Save',
  save_settings_failed: 'An error occurred while saving email settings.',
  receive: 'active',
  dont_receive: 'inactive',
  emails: 'E-Mail',
  push_notifications: 'Push',
  beekeeper_notifications: 'Beekeeper',
  setting_emails: 'E-Mail notifications',
  setting_beekeeper_notifications: 'Beekeeper notifications',
  setting_push_notifications: 'Push-Notifications',
  browser_notifications: 'Browser notifications',
  browser_notifications_enabled: 'enabled',
  browser_notifications_disabled: 'disabled',
  browser_notifications_request_again: 'Enable notifications',
  browser_notifications_unsupported: 'Not supported by this browser',
  browser_notifications_denied_hint: 'Permission denied. Please enable notifications in your browser settings.',
  browser_notifications_tutorial_link: 'Show Tutorial',
  browser_notifications_tutorial_title: 'How to enable browser notifications',
  browser_notifications_tutorial: {
    chrome: [
      'Click the padlock icon in the address bar and enable notifications.',
      'If that doesn\'t work: Click the three-dot menu in the top-right corner and select Settings.',
      'Navigate to Privacy and security > Site Settings > Notifications.',
      'Ensure that \'Sites can ask to send notifications\' is enabled.',
      'To allow keelearning directly, use the \'Add\' button under \'Allow\' and enter %{url}.',
    ],
    firefox: [
      'Click the menu button (three horizontal lines) and select Settings.',
      'Go to Privacy & Security.',
      'Under Permissions, find Notifications and click Settings.',
      'Manage permissions for each site or uncheck \'Block new requests asking to allow notifications\' to allow prompts.',
    ],
    safari: [
      'Click Safari in the top menu and select Preferences.',
      'Go to the Websites tab and select Notifications.',
      'Allow or deny notifications per website and ensure \'Allow websites to ask for permissions\' is enabled.',
    ],
    edge: [
      'Click the padlock icon in the address bar and enable notifications.',
      'Click the three-dot menu in the top-right corner and select Settings.',
      'Navigate to Cookies and site permissions > Notifications.',
      'To allow prompts, keep \'Ask before sending\' enabled.',
      'To allow keelearning directly, use the \'Add\' button under \'Allow\' and enter %{url}.',
    ],
  },
  settings_disabled: 'Unfortunately, the admin has not released this area.  <br />  Contact your admin with questions at %{email}',
}
